/** Updated Why.js with background curve and pseudo top-decor **/
import React from "react";
import "../Why/Why.css";
import { Link } from "react-router-dom";
import {
  FaCertificate,
  FaWallet,
  FaPlaneDeparture,
  FaUserTie,
} from "react-icons/fa";

const Why = () => {
  return (
    <section className="why-section">
      <div className="why-left">
        <p className="why-tag">WHY CHOOSE US</p>
        <h1 className="why-heading">Why You Should Choose Our Company</h1>

        <div className="why-cards">
          <div className="why-card">
            <div className="why-icon">
              <FaCertificate />
            </div>
            <div>
              <h4>Professional & Certified</h4>
            </div>
          </div>

          <div className="why-card">
            <div className="why-icon">
              <FaWallet />
            </div>
            <div>
              <h4>Best Price Guarantee</h4>
            </div>
          </div>

          <div className="why-card">
            <div className="why-icon">
              <FaPlaneDeparture />
            </div>
            <div>
              <h4>Get Instant Tour Bookings</h4>
            </div>
          </div>

          <div className="why-card">
            <div className="why-icon">
              <FaUserTie />
            </div>
            <div>
              <h4>Experienced Guide</h4>
            </div>
          </div>
        </div>
        <Link to="/contactus">
          <button className="why-btn">Explore More</button>
        </Link>
      </div>

      <div className="why-right">
        <div className="right-bg"></div>

        <div className="big-circle decorated">
          <img src="/couple.webp" alt="group1" />
        </div>

        <div className="small-circle">
          <img src="/beach.webp" alt="group2" />
        </div>
      </div>
    </section>
  );
};

export default Why;
